import { Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { truncateValue } from "@/utils/truncateValue";
import withConditionalTooltip from "./withConditionalTooltip";
import type { ITextWithConditionalTooltipProps } from "./TextWithConditionalTooltip.types";
import type { ComponentProps } from "react";

const TextWithConditionalTooltip = ({
  text,
  maxLength,
  isMediaQueryRequired = true,
  truncate = true,
  ...props
}: ITextWithConditionalTooltipProps) => {
  const TextWithTooltip = withConditionalTooltip<
    ComponentProps<typeof Text> & { children: string }
  >(Text);
  const matches = useMediaQuery("(min-width: 1800px)");

  const adjustedMaxLength = matches && isMediaQueryRequired ? maxLength + 30 : maxLength;
  const textValue = text || "";
  const shouldShowTooltip = textValue.length > adjustedMaxLength;

  const textProps: ComponentProps<typeof Text> = {
    ...props,
    component: "span",
    inherit: true,
    style: {
      display: "flex",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      ...props.style,
    },
  };

  return (
    <TextWithTooltip showTooltip={shouldShowTooltip} tooltipLabel={textValue} {...textProps}>
      {truncate ? truncateValue(textValue, adjustedMaxLength) : textValue}
    </TextWithTooltip>
  );
};

export default TextWithConditionalTooltip;
